import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: [],
  userGuideData: {},
  userGuideToggle: true,
};

const userSlice = createSlice({
  name: 'userGuide',
  initialState,
  reducers: {
    start: (state, action) => {
      state.error = [];
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
    },

    setErrorNew: (state, action) => {
      state.error = action.payload;
    },
    setUserGuideData: (state, action) => {
      state.userGuideData = action.payload;
      state.isLoading = false;
      state.error = [];
    },
    setUserGuideToggle: (state, action) => {
      state.userGuideToggle = !state.userGuideToggle;
    },
  },
});

export const { start, setErrorNew, setUserGuideData, setUserGuideToggle } = userSlice.actions;

export default userSlice.reducer;
